import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./app/layout";
import {LoginPage} from "./features/auth/login";
import {RequireAuth} from "@/app/require-auth";
import {TherapySessionForm} from "@/features/therapy/therapy-session-form";
import {SessionsListPage} from "@/features/therapy/sessions-list-page";
import {WeekPlanPage} from "@/features/therapy/week-plan-page";

export const router = createBrowserRouter([
    {
        path: "/login",
        element: <LoginPage />,
    },
    {
        path: "/",
        element: (
            <RequireAuth>
                <AppLayout />
            </RequireAuth>
        ),
        children: [
            {
                index: true,
                element: <WeekPlanPage />
            },
            {
                path: "week-plan",
                element: <WeekPlanPage />
            },
            {
                path: "sessions",
                element: <SessionsListPage />
            },
            {
                path: "sessions/new",
                element: <TherapySessionForm mode="session" />
            },
            {
                path: "sessions/:id/edit",
                element: <TherapySessionForm mode="session" />
            },
            {
                path: "admin/templates/new",
                element: <TherapySessionForm mode="template" />
            },
            {
                path: "admin/templates/:id/edit",
                element: <TherapySessionForm mode="template" />
            },
            {
                path: "admin/clients",
                async lazy() {
                    const { ClientsPage } = await import("./features/admin/clients/clients-page");
                    return { Component: ClientsPage };
                },
            },
            {
                path: "admin/helpers",
                async lazy() {
                    const { HelpersPage } = await import("./features/admin/helpers/helpers-page");
                    return { Component: HelpersPage };
                },
            },
            {
                path: "admin/therapists",
                async lazy() {
                    const { TherapistsPage } = await import("./features/admin/therapists/therapists-page");
                    return { Component: TherapistsPage };
                },
            },
            {
                path: "admin/horses",
                async lazy() {
                    const { HorsesPage } = await import("./features/admin/horses/horses-page");
                    return { Component: HorsesPage };
                },
            },
            {
                path: "admin/reports",
                async lazy() {
                    const { ReportsPage } = await import("./features/admin/reports/reports-page");
                    return { Component: ReportsPage };
                },
            },
            {
                path: "admin/users",
                async lazy() {
                    const { UsersPage } = await import("./features/admin/users/users-page");
                    return { Component: UsersPage };
                },
            },
        ],
    },
]);
